import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import ConfirmDialog from "../components/ConfirmDialog";
import PopupMessage from "../components/PopupMessage";
import "react-datepicker/dist/react-datepicker.css";

import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import SaveIcon from "@material-ui/icons/SaveOutlined";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import DeleteIcon from "@material-ui/icons/DeleteForeverOutlined";
import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import AddLocationIcon from "@material-ui/icons/AddLocationOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },

  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP + ACCOUNTS_TOOLBAR_HEIGHT + 10}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP + ACCOUNTS_TOOLBAR_HEIGHT}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },

  formContent: {
    marginTop: `50px`,
    position: "absolute",
    marginLeft: "50px",
    marginRight: "50px",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class DepositLocationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      actionError: "",
      notifyString: "",
      items: [],
      selectedItemKey: -1,
      selectedItemObject: {},
      totalCount: 0,
      viewPopup: false,
      viewAdd: false,
      confirmDelete: false,
      inited: false,
      showResults: false,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onCloseActionPopup = this.onCloseActionPopup.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidUpdate() {
    if (this.state.inited && !this.state.showResults) {
      this.setState({ showResults: true });
    }
  }

  componentDidMount() {
    this.setState({ inited: false });
    this.setState({ showResults: false });
    fetch("on_deposit_location_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ items: reply.items });
          this.setState({ totalCount: reply.totalCount });
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
        this.setState({ inited: true });
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
        this.setState({ inited: true });
      });
  }

  onCloseActionPopup(e) {
    this.setState({ actionError: "" });
    this.setState({ viewPopup: false });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewAdd: false });
    this.setState({ confirmDelete: false });
    this.setState({ selectedItemKey: -1 });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  handleAdd(event) {
    this.setState({ selectedItemObject: this.getEmptyItem() });
    this.setState({ viewAdd: true });
  }

  handleSelectItem(event, index) {
    this.setState({ selectedItemKey: index });
    this.setState({
      selectedItemObject: this.copyItem(this.state.items[index]),
    });
  }

  onDelete(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ confirmDelete: true });
  }

  onSave(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    let selectedObject = this.state.selectedItemObject;
    if (
      selectedObject.location === null ||
      selectedObject.location.length === 0
    ) {
      this.setState({
        actionError: getErrorString(
          "deposit.location.error",
          "Deposit Location is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (
      selectedObject.locationName === null ||
      selectedObject.locationName.length === 0
    ) {
      this.setState({
        actionError: getErrorString(
          "deposit.location.name.error",
          "Location Name is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }

    if (this.state.viewAdd) {
      this.executeAction(1);
    } else {
      this.executeAction(2);
    }
  }

  handleDelete(e, action) {
    this.setState({ confirmDelete: false });
    // confirmed
    if (action === 1) {
      this.executeAction(3);
    }
  }

  executeAction(actionNumber) {
    let items = actionNumber === 2 ? this.state.items : [];
    fetch("on_deposit_location_action", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        action: actionNumber,
        item: this.state.selectedItemObject,
        originalItems: items,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ actionError: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          this.setState({ totalCount: 0 });
          this.setState({ viewAdd: false });
          this.setState({ selectedItemKey: -1 });
          this.componentDidMount();
        }
      })
      .catch((error) => {
        this.setState({
          actionError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleLocation(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.location = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  handleLocationName(e) {
    let selectedObject = this.state.selectedItemObject;
    selectedObject.locationName = e.target.value;
    this.setState({ selectedItemObject: selectedObject });
  }

  getEmptyItem() {
    let myItem = { index: 0, location: "", locationName: "" };
    return myItem;
  }

  copyItem(item) {
    let myItem = this.getEmptyItem();
    myItem.index = item.index;
    myItem.location = item.location;
    myItem.locationName = item.locationName;
    return myItem;
  }

  isSelected = (id) => this.state.selectedItemKey === id;
  render() {
    const { classes } = this.props;
    let data = this.state.items;
    let { t } = this.props;
    return (
      <div>
        {this.state.showResults && (
          <div id="myTopDiv">
            {this.state.viewPopup && this.state.errorString.length > 0 && (
              <PopupMessage
                title="Error"
                text={this.state.errorString}
                error={true}
                onClosePopup={this.onClosePopup}
              />
            )}
            {this.state.viewPopup && this.state.notifyString.length > 0 && (
              <PopupMessage
                title="Information"
                text={this.state.notifyString}
                error={false}
                onClosePopup={this.onClosePopup}
              />
            )}
            {this.state.confirmDelete && (
              <ConfirmDialog
                title={t("confirmDelete.label")}
                text={t("deleteLocation.label")}
                onCloseConfirm={this.handleDelete}
              />
            )}
            {this.state.viewPopup && this.state.actionError.length > 0 && (
              <PopupMessage
                title="Error"
                text={this.state.actionError}
                error={true}
                onClosePopup={this.onCloseActionPopup}
              />
            )}

            <div className={classes.toolbar}>
              {!this.state.viewAdd && this.state.selectedItemKey === -1 && (
                <FormGroup row>
                  <Typography variant="h6" color="primary">
                    &nbsp;&nbsp;{t("depositLocations.label")}:&nbsp;&nbsp;
                  </Typography>
                  <Button
                    color="primary"
                    onClick={(event) => this.handleAdd(event)}
                  >
                    <AddLocationIcon />
                    &nbsp;{t("addLocation.label")}
                  </Button>
                </FormGroup>
              )}

              {this.state.viewAdd && (
                <FormGroup row>
                  <Typography variant="subheading" color="textSecondary">
                    <p>&nbsp;&nbsp; {t("newLocation.label")}: &nbsp;&nbsp;</p>
                  </Typography>
                  <Button
                    color="primary"
                    onClick={(event) => this.onSave(event)}
                  >
                    <SaveIcon />
                    &nbsp;{t("save.button")}
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => this.onClosePopup(event)}
                  >
                    <CancelIcon />
                    &nbsp;{t("cancel.button")}
                  </Button>
                </FormGroup>
              )}
              {this.state.selectedItemKey !== -1 && (
                <FormGroup row>
                  <Typography variant="headline" color="textSecondary">
                    <p>
                      &nbsp;&nbsp; {t("selectedLocation.label")}: &nbsp;&nbsp;
                    </p>
                  </Typography>
                  <Button
                    color="primary"
                    onClick={(event) => this.onClosePopup(event)}
                  >
                    <DeselectIcon />
                    &nbsp;{t("deselect.button")}
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => this.onSave(event)}
                  >
                    <SaveIcon />
                    &nbsp;{t("save.button")}
                  </Button>
                  <Button
                    color="primary"
                    onClick={(event) => this.onDelete(event)}
                  >
                    <DeleteIcon />
                    &nbsp;{t("delete.button")}
                  </Button>
                </FormGroup>
              )}

              <Divider />
            </div>
            <div className={classes.tableWrapper}>
              {(this.state.viewAdd || this.state.selectedItemKey !== -1) && (
                <div>
                  <FormGroup row>
                    <TextField
                      margin="dense"
                      id="location"
                      label={t("depositLocation.label")}
                      type="text"
                      defaultValue={this.state.selectedItemObject.location}
                      onChange={(event) => this.handleLocation(event)}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                      margin="dense"
                      id="locationName"
                      label={t("locationName.label")}
                      type="text"
                      defaultValue={this.state.selectedItemObject.locationName}
                      onChange={(event) => this.handleLocationName(event)}
                    />
                  </FormGroup>
                </div>
              )}

              {!this.state.viewAdd &&
                this.state.selectedItemKey === -1 &&
                this.state.totalCount > 0 && (
                  <div>
                    <Paper>
                      <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("depositLocation.label")}</TableCell>
                            <TableCell>{t("locationName.label")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data.map((n) => {
                            const isSelected = this.isSelected(n.index);
                            return (
                              <TableRow
                                hover
                                className={classes.tableRow}
                                onClick={(event) =>
                                  this.handleSelectItem(event, n.index)
                                }
                                key={n.index}
                                selected={isSelected}
                              >
                                <TableCell>{n.location}</TableCell>
                                <TableCell>{n.locationName}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Paper>
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

DepositLocationPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(DepositLocationPage));
